module.exports = __webpack_public_path__ + "static/media/coti_pay_black.9322646d.png";